module.exports = __webpack_public_path__ + "static/media/LoaderMagicVision.3c5813f3.svg";